import React, { FC } from 'react';
import styleModule from './RecruiterLandingAwardSection.module.less';
import Link from 'next/link';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import Image from 'next/image';
import { RightOutlined } from '@ant-design/icons';
import { useUserInfo } from '../../../connection/Application';
import { Title } from '../../../components/Typogrphy/Title';
import { PlusOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import background from '../../../public/recruiter/recruiter-landing/awardimage.png';
const styles: any = styleModule;

export const RecruiterLandingAwardSection: FC = () => {
  const user = useUserInfo();
  const history = useRouter();
  return (
    <section
      className={`relative w-screen self-center flex justify-center mt-[-20px] bg-[#f6fbfa] text-[#050931] ${styles.SectioCont}`}>
      <div className="w-full max-w-[1600px] px-[20px] md:px-[65px] py-[40px] flex items-center z-10 flex-col lg:flex-row gap-8 lg:gap-0">
        <div className={`grow shrink z-10 ${styles.bannerTextCont}`}>
          <div className={styles.bannerTextAward}>
            <span className={styles.awardHeading}>
              Make <span style={{ color: '#009E52' }}> good hires </span> easily
            </span>
            <span className={styles.awardHeading2}>
              Careers360 is a powerful, user-friendly recruitment <br />
              solution.
            </span>
          </div>
        </div>
        {/* <div className={styles.awardImg}>
          <Image
            src={background}
            alt={'Banner Background'}
            // className={styles.bannerImage}
            // style={{
            //   color: 'transparent',
            //   position: 'inherit',
            //   width: '600px',
            //   height: '500px',
            //   margin: 'auto',
            // }}
          />
        </div> */}
        {/* <div className={` ${styles.bannerImageCont}`}> */}
        <Image
          src={background}
          alt={'Banner Background'}
          className={styles.bannerImage}
          // style={{
          //   color: 'transparent',
          //   position: 'inherit',
          //   width: '600px',
          //   height: '500px',
          //   margin: 'auto',
          // }}
        />
        {/* <div className={styles.topRightDiv}>
          <Image
            src={background}
            alt={'Banner Background'}
            className={styles.bannerImage}
            // style={{
            //   color: 'transparent',
            //   position: 'inherit',
            //   width: '600px',
            //   height: '500px',
            //   margin: 'auto',
            // }}
          />
        </div> */}
        {/* </div> */}
      </div>
    </section>
  );
};
